// store/admin/exam-management/store/_actionTypes.js

// Get all exams
export const GET_ALL_EXAMS_REQUEST = 'GET_ALL_EXAMS_REQUEST';
export const GET_ALL_EXAMS_SUCCESS = 'GET_ALL_EXAMS_SUCCESS';
export const GET_ALL_EXAMS_FAILURE = 'GET_ALL_EXAMS_FAILURE';

// Get exam by ID
export const GET_EXAM_BY_ID_REQUEST = 'GET_EXAM_BY_ID_REQUEST';
export const GET_EXAM_BY_ID_SUCCESS = 'GET_EXAM_BY_ID_SUCCESS';
export const GET_EXAM_BY_ID_FAILURE = 'GET_EXAM_BY_ID_FAILURE';

// Create exam
export const CREATE_EXAM_REQUEST = 'CREATE_EXAM_REQUEST';
export const CREATE_EXAM_SUCCESS = 'CREATE_EXAM_SUCCESS';
export const CREATE_EXAM_FAILURE = 'CREATE_EXAM_FAILURE';

// Update exam
export const UPDATE_EXAM_REQUEST = 'UPDATE_EXAM_REQUEST';
export const UPDATE_EXAM_SUCCESS = 'UPDATE_EXAM_SUCCESS';
export const UPDATE_EXAM_FAILURE = 'UPDATE_EXAM_FAILURE';

// Delete exam
export const DELETE_EXAM_REQUEST = 'DELETE_EXAM_REQUEST';
export const DELETE_EXAM_SUCCESS = 'DELETE_EXAM_SUCCESS';
export const DELETE_EXAM_FAILURE = 'DELETE_EXAM_FAILURE';

// Toggle exam status
export const TOGGLE_EXAM_STATUS_REQUEST = 'TOGGLE_EXAM_STATUS_REQUEST';
export const TOGGLE_EXAM_STATUS_SUCCESS = 'TOGGLE_EXAM_STATUS_SUCCESS';
export const TOGGLE_EXAM_STATUS_FAILURE = 'TOGGLE_EXAM_STATUS_FAILURE';

// Declare exam results
export const DECLARE_EXAM_RESULTS_REQUEST = 'DECLARE_EXAM_RESULTS_REQUEST';
export const DECLARE_EXAM_RESULTS_SUCCESS = 'DECLARE_EXAM_RESULTS_SUCCESS';
export const DECLARE_EXAM_RESULTS_FAILURE = 'DECLARE_EXAM_RESULTS_FAILURE';

// Get exam attempts
export const GET_EXAM_ATTEMPTS_REQUEST = 'GET_EXAM_ATTEMPTS_REQUEST';
export const GET_EXAM_ATTEMPTS_SUCCESS = 'GET_EXAM_ATTEMPTS_SUCCESS';
export const GET_EXAM_ATTEMPTS_FAILURE = 'GET_EXAM_ATTEMPTS_FAILURE';

// Get exam analytics (live)
export const GET_EXAM_ANALYTICS_REQUEST = 'GET_EXAM_ANALYTICS_REQUEST';
export const GET_EXAM_ANALYTICS_SUCCESS = 'GET_EXAM_ANALYTICS_SUCCESS';
export const GET_EXAM_ANALYTICS_FAILURE = 'GET_EXAM_ANALYTICS_FAILURE';
export const CLEAR_EXAM_ANALYTICS = 'CLEAR_EXAM_ANALYTICS';

// Add/Update questions
export const ADD_EXAM_QUESTIONS_REQUEST = 'ADD_EXAM_QUESTIONS_REQUEST';
export const ADD_EXAM_QUESTIONS_SUCCESS = 'ADD_EXAM_QUESTIONS_SUCCESS';
export const ADD_EXAM_QUESTIONS_FAILURE = 'ADD_EXAM_QUESTIONS_FAILURE';

export const UPDATE_EXAM_QUESTIONS_REQUEST = 'UPDATE_EXAM_QUESTIONS_REQUEST';
export const UPDATE_EXAM_QUESTIONS_SUCCESS = 'UPDATE_EXAM_QUESTIONS_SUCCESS';
export const UPDATE_EXAM_QUESTIONS_FAILURE = 'UPDATE_EXAM_QUESTIONS_FAILURE';

// Local state management
export const SET_SELECTED_EXAM = 'SET_SELECTED_EXAM';
export const CLEAR_EXAM_ERROR = 'CLEAR_EXAM_ERROR';
export const RESET_EXAM_FORM = 'RESET_EXAM_FORM';